import { defineComponent, h } from 'vue';
import { QInput, QSelect } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { wrapPropertyGridRow } from './pg2Wrap.jsx';

export default defineComponent({
    name: 'form2-anyof',
    components: { QInput, QSelect },
    data: function () {
        return {
            condition_expn: null,
        };
    },
    created() {},
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        async sync(prop, value) {
            let item;
            if (value == '!!null!!') item = {};
            else {
                let schema = this.schema.anyOf[value];
                schema = utils.schema.resolve_Of(schema);
                item = utils.schema.createDefaultModel(schema, this.root);
            }

            if (Array.isArray(this.cmodel)) {
                if (prop < this.cmodel.length) this.cmodel[prop] = item;
                else {
                    while (this.cmodel.length < prop) this.cmodel.push(null);

                    this.cmodel.push(item);
                }
            } else {
                this.cmodel[prop] = item;
            }
        },
        extractDocument() {
            debugger;
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        navigateTo: null,
        canNavigate: false,
        extractor: null,
        propertygrid: false,
        arrayItemInline: { type: Boolean, default: false },
    },
    render() {
        if (!this.Condition) return null;

        let desc;
        if (this.schema.description)
            desc = (
                <i
                    class="mdi mdi-information"
                    title={this.schema.description}
                    style={{ color: 'var(--v-checkboxGrey-base)', fontSize: 'small', marginLeft: '3px' }}
                ></i>
            );

        const name = <span style={{ marginLeft: this.child * 15 + 'px' }}>{this.name}</span>;
        if (this.readonly)
            return wrapPropertyGridRow(
                this,
                () => (
                    <span class="c-PropertyGrid2__labelInner">
                        {name} {desc}
                    </span>
                ),
                () => (
                    <QInput
                        borderless
                        dense
                        hide-bottom-space
                        style={{ width: '100%' }}
                        modelValue={this.cmodel[this.schemakey]}
                        readonly
                    />
                ),
            );

        const items = [];
        const schema = this.schema;
        let value;
        let found = false;
        for (var i = 0; i < schema.anyOf.length; i++) {
            const item = schema.anyOf[i];

            if (this.cmodel[this.schemakey] && this.cmodel[this.schemakey].$typeSchema === item.Id) {
                found = true;
                value = i;
            }

            items.push({ text: item.title, value: i });
        }

        items.splice(0, 0, { text: '-None-', value: '!!null!!' });

        let navigate;
        let extract;
        if (this.canNavigate && found) {
            navigate = (
                <i
                    title="Edit"
                    class="mdi mdi-open-in-new"
                    style={{ cursor: 'pointer', color: 'blue', marginLeft: '3px' }}
                    onClick={() => this.navigateTo(this, this.name)}
                ></i>
            );

            if (
                this.extractor &&
                (this.schema.Id == '/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/DynamicControl' ||
                    this.schema.Id == '/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/UIAction')
            )
                extract = (
                    <i
                        title="Extract Document"
                        class="mdi mdi-share"
                        style={{ cursor: 'pointer', color: 'blue', marginLeft: '3px' }}
                        onClick={() => this.extractor(this, this.name)}
                    ></i>
                );
        }

        return wrapPropertyGridRow(
            this,
            () => (
                <span class="c-PropertyGrid2__labelInner">
                    {name} {desc} {navigate}
                </span>
            ),
            () => (
                <span style={{ display: 'flex', alignItems: 'center', minWidth: 0, width: '100%' }}>
                    <QSelect
                        borderless
                        dense
                        hide-bottom-space
                        option-label="text"
                        option-value="value"
                        options-dense
                        emit-value
                        map-options
                        options={items}
                        modelValue={value}
                        style={{ width: '100%', ...(this.propertygrid ? { minWidth: 0 } : { minWidth: '160px' }) }}
                        popup-content-class="q-select-max-popup-height"
                        onUpdate:modelValue={(value) => this.sync(this.schemakey, value)}
                    />
                    {extract}
                </span>
            ),
        );
    },
});
